<template>
     <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pb-2 mt-1">
                <v-col sm="8" md="4" class="py-0">
                    <v-text-field
                        v-model="props.search"
                        append-icon="search"
                        :label="$t('fulfillments_prepaid_sent.search')"
                        single-line
                        hide-details
                        class="mb-4 py-0 px-2 mt-0"
                        style="background-color: var(--v-white_highlight-base); border: 1px solid black; border-radius:5px"
                    ></v-text-field>
                </v-col>
                <!-- <v-spacer></v-spacer>  -->
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row>
                        <v-col class="py-0">
                            <datatable :pagination="[10, 25, 50, 100]" :props="{headers:headers, items: props.items, search:props.search}" :itemsLength="props.meta.total" :options.sync="pagination.pendings" @update:options="(options) => onOptionsChange(options)" @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
            <v-dialog v-model="modalDelete" persistent max-width="90%">
                <v-card >
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                            <h3 class="text-uppercase">
                                {{ $t('fulfillments_prepaid_sent.modal.delete') }}
                            </h3>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-row align="center" justify="center" class="py-3 my-3 text-center">
                            <v-col cols="12">
                                <h5>{{ $t('fulfillments_prepaid_sent.modal.message') }}</h5>
                            </v-col>
                        </v-row>
                        
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" text @click="modalDelete = false">{{ $t('fulfillments_prepaid_sent.no') }}</v-btn>
                            <v-btn color="error" @click="deleteOrder">
                                {{ $t('fulfillments_prepaid_sent.yes') }}
                            </v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker"></div>
                </v-card>
            </v-dialog>
            <v-dialog v-model="modalDetail" persistent max-width="90%" v-if="orderToShow != null">
                <v-card style="min-width: 700px !important">
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                            <h4 class="text-uppercase blue_accent--text py-2">
                                {{ $t('fulfillments_prepaid_sent.order_details.header') }} {{ this.orderToShow.uniqueOrderNumber }}
                            </h4>
                        </v-row>
                    </v-card-title>
                    
                    <div class="marker1-1" style="font-weight:bold"><label class="mx-1">{{ $t('fulfillments_prepaid_sent.details') }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_sent.order_number") }}</label> <label>{{ this.orderToShow.uniqueOrderNumber }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_sent.date") }}</label> <label>{{ this.orderToShow.createdAt }}</label></div>
                    <div class="detail_content1" v-if="shipping_service != 'otra'"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.shipping_service") }}</label> <label>{{ this.orderToShow.shippingService }}</label></div>
                    <div class="detail_content1" v-if="shipping_service == 'otra'"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.shipping_service") }}</label> <label>{{ this.orderToShow.externalShippingService }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.invoice") }}</label> <label>{{ this.orderToShow.invoice }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.client != null"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_sent.client") }}</label> <label>{{ this.orderToShow.client.name }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_sent.cod") }}</label> <label>{{ this.orderToShow.total }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_sent.buyer") }}</label> <label>{{ this.orderToShow.consignee.name }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_sent.state") }}</label> <label>{{ this.orderToShow.consignee.state }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_sent.municipality") }}</label> <label>{{ this.orderToShow.consignee.municipality }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_sent.neighborhood") }}</label> <label>{{ this.orderToShow.consignee.neighborhood }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.address") }}</label> <label>{{ this.orderToShow.consignee.street }} {{ this.orderToShow.consignee.externalNumber }} {{ this.orderToShow.consignee.internalNumber }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_sent.zip_code") }}</label> <label>{{ this.orderToShow.consignee.zipcode }}</label></div>
                    
                    <div class="marker1-1 mt-2" style="font-weight:bold"><label class="mx-1">{{ $t('fulfillments_prepaid_sent.products') }}</label></div>
                    <span v-if="orderToShow.shipmentProductDetail != null">
                        <div v-for="(product, i) of orderToShow.shipmentProductDetail.data" :key="i" class="detail_content1"><label style="font-weight:bold">{{ product.attributes.product.sku }}</label> <label>{{ product.attributes.quantity }}</label></div>
                    </span>
                    
                    <div class="marker1-1 mt-2" style="font-weight:bold"><label class="mx-1">{{ $t('fulfillments_prepaid_sent.tracking_history') }}</label></div>
                    <div v-for="status of orderToShow.orderStatus" :key="status.id" class="detail_content1"><label style="font-weight:bold">{{ status.attributes.status }}</label> <label>{{ status.attributes.createdAt }}</label></div>

                    <v-card-text class="mt-5">
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn  color="secondary" class="white_highlight--text" @click="modalDetail = false">
                                {{ $t('fulfillments_prepaid_sent.go_back') }}
                            </v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker1"></div>
                </v-card>
            </v-dialog>
            <v-dialog v-model="modalRestore" persistent max-width="90%">
                <v-card >
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                            <h3 class="text-uppercase">
                                {{ $t('fulfillments_cod_in_process.restore_modal.restore') }}
                            </h3>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-row align="center" justify="center" class="py-3 my-3 text-center">
                            <v-col cols="12">
                                <h5>{{ $t('fulfillments_cod_in_process.restore_modal.message') }}</h5>
                            </v-col>
                        </v-row>
                        
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" text @click="modalRestore = false">{{ $t('fulfillments_cod_in_process.no') }}</v-btn>
                            <v-btn color="error" @click="restoreOrder">
                                {{ $t('fulfillments_cod_in_process.yes') }}
                            </v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker"></div>
                </v-card>
            </v-dialog>
            <v-dialog v-model="modalAlreadyOpen" persistent max-width="50%">
                <v-card>
                    <v-row align="center" justify="center" class="text-center py-8 px-10">
                        <v-col cols="12">
                            <h3>{{ $t('fulfillments_cod_pendings.multiple_fulfillment_tabs') }}</h3>
                        </v-col>
                    </v-row>
                    <div class="marker"></div>
                </v-card>
            </v-dialog>
        </v-container>        
    </div>
</template>

<script>

import { HttpShipmentRepository } from '../../../infrastructure/shipment_repository';
import { shipmentsIndexUseCase } from '../../../application/use_cases/shipments_index_use_case';
import { shipmentsShowUseCase } from '../../../application/use_cases/shipments_show_use_case';

export default {
	computed: {
        headers(){
            if(this.shipping_service != "otra"){
                return [
                    { text: this.$t('fulfillments_prepaid_sent.order'), value: 'unique_order_number' },
                    { text: this.$t('fulfillments_prepaid_sent.client'), value: 'client.name' },
                    { text: this.$t('fulfillments_prepaid_sent.shipping_number'), value: 'shipment_number' },
                    // { text: this.$t('fulfillments_prepaid_sent.pickup'), value: 'pickup' },
                    { text: this.$t('fulfillments_prepaid_sent.status'), value: 'last_status' },
                    { text: this.$t('fulfillments_prepaid_sent.actions'), value: 'actions' },
                ];
            }
            else {
                return [
                    { text: this.$t('fulfillments_prepaid_sent.order'), value: 'unique_order_number' },
                    { text: this.$t('fulfillments_prepaid_sent.shipping_service'), value: 'external_shipping_service' },
                    { text: this.$t('fulfillments_prepaid_sent.client'), value: 'client.name' },
                    { text: this.$t('fulfillments_prepaid_sent.shipping_number'), value: 'shipment_number' },
                    // { text: this.$t('fulfillments_prepaid_sent.pickup'), value: 'pickup' },
                    { text: this.$t('fulfillments_prepaid_sent.status'), value: 'last_status' },
                    { text: this.$t('fulfillments_prepaid_sent.actions'), value: 'actions' },
                ];
            }
        }
    },
    data(){
        return {
            shipping_service: this.$route.params.shipping_service,
            props: {
                search: '',
                items: [],
                meta: {
                    total: 0,
                    total_pages: 0,
                    per_page: 10,
                    page: 1
                },
                sort_by: []
            },
            debounceTimer: null,
            pagination: {page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [], groupBy: [], groupDesc: [], multiSort: false, mustSort: false},
            modalDelete: false,
            modalDetail: false,
            modalRestore: false,
            modalAlreadyOpen: false,
            orderToDelete: '',
            orderToShow: '',
            orderToRestore: '',
        }
    },
    async mounted(){
        this.$store.state.module = "headers." + this.shipping_service + "_prepaid_sent";
        await this.checkIfCanOpen(this.shipping_service);        
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        async index(){
            try{
                this.props.items = [];

                const res = await shipmentsIndexUseCase('getSentOrders', this.props.meta.page, this.props.meta.per_page, this.props.search, this.shipping_service.toUpperCase(), 'false', this.props.sort_by, HttpShipmentRepository);

                this.props.items = res.data.data;
                this.props.meta = res.data.meta;
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        async showDetails(order){
            this.orderToShow = order;

            try {
                const res = await shipmentsShowUseCase(order.id, HttpShipmentRepository);

                this.orderToShow = res;
                this.modalDetail = true;
            }
            catch(e) {
                console.log(e)
                this.snackbar = {
                    visible: true,
                    color: 'red',
                    text: e.response
                }
            }
        },
        supplyOrder(order){
            console.log(order.uon);

        },
        askDelete(order){
            this.modalDelete = true;
            this.orderToDelete = order;
        },
        askRestore(order){
            this.modalRestore = true;
            this.orderToRestore = order;
        },
        restoreOrder(){
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            if(this.orderToRestore != ''){
                this.$http.put(this.$store.state.chronosApi + 'shipment/restock/' + this.orderToRestore.id, {}, {headers: {Authorization: lsToken}})
                .then((response) => {
                    if(response.data.code === 200) {
                        this.orderToRestore = '';
                        this.modalRestore = false;
                        this.snackbar = {
                            visible: true,
                            color: 'success2',
                            text: this.$t('fulfillments_cod_sent.restored')
                        }
                        this.index();
                    }
                }).catch((err) => {
                    console.log(err);
                }).finally(() => {
                    this.$store.state.loaderProps.visible = false;
                })
            }
            else{
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: "error"
                }
            }
        },
        deleteOrder(){
            console.log(this.orderToDelete);
        },
        async onOptionsChange(options) {
            this.props.meta.page = options.page;
            this.props.meta.per_page = options.itemsPerPage;
            
            if(options.sortBy.length > 0){
                this.props.meta.page = 1;
                this.props.sort_by = [{field: options.sortBy[0], direction: options.sortDesc[0] ? 'desc' : 'asc'}];
            } 
            else if(options.sortBy.length != this.props.sort_by.length) {
                this.props.meta.page = 1;
                this.props.sort_by = [];
            } 

            this.index();
        },
        checkIfCanOpen(parcel){
            localStorage.open_pages = Date.now();
            window.addEventListener('storage', (e) => {
                if(e.key == "open_pages") localStorage.setItem("fulfillment_" + parcel, Date.now())
                if(e.key == "fulfillment_" + parcel) this.modalAlreadyOpen = true;              
            }, false);
        },
    },
    watch:{
        '$route.params.shipping_service': function() {
            location.reload();
        },
        'props.search': async function(){
            clearTimeout(this.debounceTimer)

            this.debounceTimer = setTimeout(() => {
                if(this.modalAlreadyOpen == false) this.index();
            }, 800);
        },
    }
}
</script>

<style lang="scss">
    .marker1{
        width: 100%;
        background-color: #c1d500;
        height: 12px;
        bottom: 0px;
    }
    .marker1-1{
        width: 90%;
        margin:auto;
        background-color: #c1d500;
        height: 20px;
    }
    .detail_content{
        width: 90%;
        margin: auto;
        border-bottom: 1px solid black;
        padding: 0 .35em;
        display: flex;
        justify-content: space-between;
    }
    .detail_content1{
        width: 90%;
        margin: auto;
        border-bottom: 1px solid black;
        padding: 0 .35em;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
    }
</style>